import { gql } from 'apollo-angular';

const GET_PRICE_INCREASES = gql`
  query getPriceIncreases($id: Long!) {
    offer(id: $id) {
      priceIncreases {
        productId
        offerId
        currentPrice
        offerPrice
        product {
          id
          catalogNumber
          description
        }
        buyer {
          id
          name
        }
      }
    }
  }
`;

export default GET_PRICE_INCREASES;
